import React, { useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { TbHandClick } from "react-icons/tb";

function Sidebar() {
    // window.location.reload();
    const path = useLocation();

    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };


    // close sidebar will work after responsive only
    const close_sidebar = () => {
        document.body.classList.add("sidebar-closed");
        document.body.classList.remove("sidebar-open");

        if (window.screen.width <= 992 && window.screen.width >= 768) {
            document.body.classList.add("sidebar-collapse");
        }

    };


    return (
        <Aside className="main-sidebar sidebar-light-secondary elevation-4" style={{ height: "100vh" }}>
            {/* {/ Brand Logo /} */}
            <Link to="/dashboard"
                className="brand-link"
                onClick={close_sidebar}
            >
                <img src="dist/img/logo.png" alt="AdminLTE Logo" className="brand-image elevation-3" style={{ opacity: '.8' }} />
                <span className="brand-text font-weight-light">Naariyal Paniwala</span>
            </Link>
            {/* {/ Sidebar /} */}
            <div className="sidebar overflow-auto">


                {/* {/ Sidebar Menu /} */}
                <nav className="mt-3">
                    <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">


                        <ul className='nav'>
                            <li className="nav-item">
                                <Link
                                    to="/dashboard"
                                    className={`nav-link mb-2 ${path.pathname === '/dashboard' ? 'active-sidebar-title' : ''}`}
                                    onClick={close_sidebar}
                                >
                                    <i className="nav-icon fas fa-th" />
                                    <p>Dashboard</p>
                                </Link>
                            </li>
                        </ul>

                        <ul className='nav'>
                            <li className="nav-item">
                                <Link
                                    to="/product"
                                    className={`nav-link mb-2 ${path.pathname === '/product' ? 'active-sidebar-title' : ''}`}
                                    onClick={close_sidebar}
                                >
                                    <i className="nav-icon fas fa-box-open"></i>
                                    <p>Product</p>
                                </Link>
                            </li>
                        </ul>

                        <ul className='nav'>
                            <li className="nav-item">
                                <Link
                                    to="/stock-history"
                                    className={`nav-link mb-2 ${path.pathname === '/stock-history' ? 'active-sidebar-title' : ''}`}
                                    onClick={close_sidebar}
                                >
                                    <i className="nav-icon fa-solid fa-clock-rotate-left"></i>
                                    {/* <i className="nav-icon fa-regular fa-hourglass-half"></i> */}
                                    <p>Stock History</p>
                                </Link>
                            </li>
                        </ul>

                        <li className="nav-item">
                            <Link
                                to="/state"
                                className={`nav-link mb-2 ${path.pathname === '/state' ? 'active-sidebar-title' : ''} ${path.pathname === '/city' ? 'active-sidebar-title' : ''} ${path.pathname === '/area' ? 'active-sidebar-title' : ''}`}
                                onClick={close_sidebar}
                            >
                                <i className="nav-icon fas fa-map-marker-alt"></i>
                                <p>
                                    Locations
                                </p>
                            </Link>
                        </li>


                        <div id='collapseList'>
                            <li className={`nav-item`}>
                                <Link
                                    className={`nav-link mb-2 collapsed ${openMenu === 'users' ? 'active-sidebar-title' : ''}`}
                                    data-toggle="collapse"
                                    data-target="#collapseLayoutUsers"
                                    aria-expanded={openMenu === 'users'}
                                    aria-controls="collapseLayouts"

                                    onClick={() => toggleMenu('users')}
                                >
                                    <i className="nav-icon fas fa-users"></i>
                                    <p>
                                        Users
                                        <i className={`right fas fa-angle-left ${openMenu === 'users' ? 'rotate' : ''}`} />
                                    </p>
                                </Link>
                                <div className="collapse" id="collapseLayoutUsers" aria-labelledby="headingOne" data-parent="#collapseList">
                                    <nav className="sb-sidenav-menu-nested nav" >
                                        <Link
                                            to="/customer"
                                            className={`nav-link mb-2 ${path.pathname === '/customer' ? 'active-sidebar-title' : ''}`}
                                            onClick={close_sidebar}
                                        >
                                            <i className="far fa-circle nav-icon" />
                                            <p>Customer</p>
                                        </Link>
                                        <Link
                                            to="/delivery-boy"
                                            className={`nav-link mb-2 ${path.pathname === '/delivery-boy' ? 'active-sidebar-title' : ''}`}
                                            onClick={close_sidebar}
                                        >
                                            <i className="far fa-circle nav-icon" />
                                            <p>Delivery Boy</p>
                                        </Link>
                                    </nav>
                                </div>
                            </li>


                            <li className={`nav-item`}>
                                <Link
                                    className={`nav-link mb-2 collapsed ${openMenu === 'orders' ? 'active-sidebar-title' : ''}`}
                                    data-toggle="collapse"
                                    data-target="#collapseLayoutOrders"
                                    aria-expanded={openMenu === 'orders'}
                                    aria-controls="collapseLayouts"
                                    onClick={() => toggleMenu('orders')}

                                >
                                    <i className="nav-icon fa-solid fa-cart-shopping"></i>
                                    <p>
                                        Orders
                                        <i className={`right fas fa-angle-left ${openMenu === 'orders' ? 'rotate' : ''}`} />
                                    </p>
                                </Link>
                                <div className="collapse" id="collapseLayoutOrders" aria-labelledby="headingOne" data-parent="#collapseList">
                                    <nav className="sb-sidenav-menu-nested nav">
                                        <Link
                                            to="/orders"
                                            className={`nav-link mb-2 ${path.pathname === '/orders' ? 'active-sidebar-title' : ''}`}
                                            onClick={close_sidebar}
                                        >
                                            <i className="far fa-circle nav-icon" />
                                            <p>Orders</p>
                                        </Link>
                                        <Link
                                            to="/sub-orders"
                                            className={`nav-link mb-2 ${path.pathname === '/sub-orders' ? 'active-sidebar-title' : ''}`}
                                            onClick={close_sidebar}
                                        >
                                            <i className="far fa-circle nav-icon" />
                                            <p>Sub Orders</p>
                                        </Link>
                                        <Link
                                            to="/failed-orders"
                                            className={`nav-link mb-2 ${path.pathname === '/failed-orders' ? 'active-sidebar-title' : ''}`}
                                            onClick={close_sidebar}
                                        >
                                            <i className="far fa-circle nav-icon" />
                                            <p>Failed order</p>
                                        </Link>
                                    </nav>
                                </div>
                            </li>
                        </div>

                        <li className="nav-item">
                            <Link
                                to="/payment-history"
                                className={`nav-link mb-2 ${path.pathname === '/payment-history' ? 'active-sidebar-title' : ''}`}
                                onClick={close_sidebar}
                            >
                                <i className="nav-icon fa-solid fa-clock-rotate-left"></i>
                                {/* <i className="nav-icon fa-regular fa-hourglass-half"></i> */}
                                <p>
                                    Payment History
                                </p>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link
                                to="/request-for-dietician"
                                className={`nav-link mb-2 ${path.pathname === '/request-for-dietician' ? 'active-sidebar-title' : ''}`}
                                onClick={close_sidebar}
                            >
                                <i className="nav-icon fa-solid fa-code-pull-request"></i>
                                <p>
                                    Request For Dietitian
                                </p>
                            </Link>
                        </li>

                        <li className="nav-item">
                            <Link
                                to="/privacy-policy"
                                className={`nav-link mb-2 ${path.pathname === '/privacy-policy' ? 'active-sidebar-title' : ''}`}
                                onClick={close_sidebar}
                            >
                                <i className="nav-icon fa-regular fa-file"></i>
                                <p>
                                    Privacy Policy
                                </p>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                to="/terms-and-conditions"
                                className={`nav-link mb-2 ${path.pathname === '/terms-and-conditions' ? 'active-sidebar-title' : ''}`}
                                onClick={close_sidebar}
                            >
                                <i className="nav-icon fa-regular fa-file"></i>
                                <p>
                                    Terms & Conditions
                                </p>
                            </Link>
                        </li>

                    </ul>
                </nav>
                {/* {/ /.sidebar-menu /} */}
            </div>
            {/* {/ /.sidebar /} */}
        </Aside>
    )
}

export default Sidebar


const Aside = styled.aside`
        background-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.black};
        width: 250px;

        .brand-link {
            border-bottom: 1px solid #d6d7d8;
            color: ${({ theme }) => theme.colors.black};
            padding: 1.1rem .5rem;
            font-size: 1.20rem;

            &:hover {
                color: ${({ theme }) => theme.colors.black};
            }

            .brand-text {
                padding-right: 5px;
            }
        }

        

        .elevation-3 {
            box-shadow: none !important;
        }

        .elevation-4{
            box-shadow: none !important;
        }
`; 